import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./studentPaymentForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {PAYMENT_STATUS_STUDENT_PENDING, PAYMENT_STATUS_STUDENT_PAID} from "../../utils/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import * as yup from 'yup';
import {useViewport} from "../../components/viewport";

const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});

const columns = [
    { id: 'name', label: 'Student Name', minWidth: 170 },
    { id: 'programLvl', label: 'Level', minWidth: 100 },
    // {
    //     id: 'icNo',
    //     label: 'NRIC No.',
    //     minWidth: 150,
    //     align: 'right',
    //     format: (value) => value.toLocaleString('en-US'),
    // },
    {
        id: 'totalOwedFee',
        label: 'Total Fee',
        minWidth: 110,
        align: 'right',
        format: (value) => value.toFixed(2),
    },
    {
        id: 'paymentStatus',
        label: 'Status',
        minWidth: 100,
        align: 'right',
        format: (value) => {
            if (value === "PAID"){
                return (<span style={{color: "green", fontWeight:"bold"}}>{value}</span>)
            }
            return (<span style={{color: "red", fontWeight:"bold"}}>{value}</span>) },
    },
    {
        id: 'month',
        label: 'Month',
        minWidth: 120,
        align: 'right',
        format: (value) => {return moment(value, "MM-YYYY").format('MMM YYYY')},
    },
    {
        id: 'transactionDate',
        label: 'Transaction Date',
        minWidth: 110,
        align: 'right',
        format: (value) => {return value? moment(value, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD') : "NA"},
    },
    {
        id: 'transactionType',
        label: 'Type',
        minWidth: 70,
        align: 'right',
        format: (value) => {return value ? value : "NA"},
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 140,
        align: 'right',
    },
];

const StudentPaymentForm = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAllTeachers, getAllTuitionFees, getAllMisc } = actions.generalActions;
    const { getStudentPayments, getSingleStudentPaymentDetail, showStudentDetailDialog, submitStudentPaymentDetail, submitStudentMiscPaymentDetail } = actions.paymentActions;
    const { studentPayment, studentPaymentDetail } = state.paymentStates;
    const [selectedDate, handleDateChange] = useState(new Date());
    const [selectedTransactionDate, setTransactionDate] = useState(null);
    const { studentDetailDialogVisible } = state.paymentStates;
    const { misc } = state.generalStates;
    const [errorMsg, setErrorMsg] = useState("");
    const [ paymentDetail, setPaymentDetail ] = useState([]);
    const [ paymentType, setPaymentType ] = useState("");
    const [ miscPaymentEnable, enableMiscPayment ] = useState(true);
    const { width } = useViewport();

    useEffect(() => {
        getAllTeachers();
        getAllTuitionFees();
        getAllMisc();
        // getStudentPayments(moment().get('month')+1);
        const month = moment(selectedDate).format('MM-YYYY') ;
        getStudentPayments(month);
    }, []);

    useEffect(() => {
        enableMiscPayment(true);
        setPaymentDetail(studentPaymentDetail);
        let shouldEnableMiscPayment = false;
        for (let i = 0; i < studentPaymentDetail.length; i++) {
            if (studentPaymentDetail[i].paymentStatus === PAYMENT_STATUS_STUDENT_PAID) {
                shouldEnableMiscPayment = false;
                setTransactionDate(moment(studentPaymentDetail[i].transactionDate, "DD-MM-YYYY"));
                setPaymentType(studentPaymentDetail[i].transactionType);
            } else {
                shouldEnableMiscPayment = true;
            }
        }
        enableMiscPayment(shouldEnableMiscPayment);
    }, [studentPaymentDetail]);

    const [programLvl, setProgramLvl] = React.useState(null);
    const [studentName, setStudentName] = React.useState(null);
    const formRef = useRef();
    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handlePaymentTypeChange = (event) => {
        setPaymentType(event.target.value);
    };

    const handleStudentNameChange = (event) => {
        setStudentName(event.target.value);
    };

    const onPayNowClick = (nric) => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        showStudentDetailDialog(true);
        getSingleStudentPaymentDetail(nric, month);
        // for (let i = 0; i < studentPayment.length; i++) {
        //     if (studentPayment[i].nric === nric){
        //         getSingleStudentPaymentDetail(studentPayment[i].uuid);
        //         break;
        //     }
        // }
    };

    const handleClose = () => {
        showStudentDetailDialog(false);
    };

    const handlePayNow = () => {
        if (paymentType.length === 0){
            setErrorMsg("Please select ur payment");
            return;
        }

        if (selectedTransactionDate == null){
            setErrorMsg("Please enter your transaction date");
            return;
        }

        console.log(paymentDetail);

        if (formRef.current) {
            formRef.current.handleSubmit();
        }

        const month = moment(selectedDate).format('MM-YYYY') ;
        const transactionDate = moment(selectedTransactionDate).format('DD-MM-YYYY') ;
        if(paymentDetail == null){
            return;
        }
        for (let i = 0; i < paymentDetail.length; i++){
            paymentDetail[i].transactionDate = transactionDate;
            paymentDetail[i].paymentType = paymentType;
        }
        // _.remove(paymentDetail, {
        //     paymentStatus: "PAID"
        // });
        submitStudentPaymentDetail(paymentDetail, () => getStudentPayments(month));
        showStudentDetailDialog(false);
        setErrorMsg("");
    };

    const handleSearchButton = () => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        getStudentPayments(month, studentName, programLvl);
    };

    const handleFeeChange = (event, row) => {
        const array = JSON.parse(JSON.stringify(paymentDetail));
        _.find(array, { subscriptionId: row.subscriptionId }).fee = parseFloat(event.target.value);
        setPaymentDetail(array);
    };

    const renderStudentDetails = () => {
        let totalFee = 0;
        if(paymentDetail == null){
            return;
        }

        for (let i = 0; i < paymentDetail.length; i++){
            if (paymentDetail[i].paymentStatus === PAYMENT_STATUS_STUDENT_PENDING) {
                totalFee += paymentDetail[i].fee;
            }
        }

        const  courseDetails  = (
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Subject Name.</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Status</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="right">Fee</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paymentDetail.map((row, index) => (
                            <TableRow key={row.subjectName}>
                                <TableCell>{row.subjectName}</TableCell>
                                <TableCell>{row.paymentStatus}</TableCell>
                                <TableCell align="right">
                                    <TextField
                                        onChange={(event) => handleFeeChange(event, row)}
                                        label="Fee"
                                        key={`${row.subjectName}${row.subscriptionId}`}
                                        defaultValue={row.fee}/>
                                </TableCell>
                            </TableRow>
                        ))}

                        {/*<TableRow>*/}
                        {/*    <TableCell rowSpan={3} />*/}
                        {/*    <TableCell colSpan={1}><b>Total</b></TableCell>*/}
                        {/*    <TableCell align="right"><b>{totalFee}</b></TableCell>*/}
                        {/*</TableRow>*/}
                    </TableBody>
                </Table>
            </TableContainer>
        )
                // <div>
                //     <TextField margin="dense" label="Nric No."
                //                value={obj.subject} fullWidth disabled
                //     />
                //     <TextField margin="dense" label="Nric No."
                //                value={obj.fee} fullWidth disabled
                //     />
                // </div>
        if (paymentDetail.length> 0) {
            return (
                <div>
                    <TextField margin="dense" label="Name"
                               value={paymentDetail[0].name} fullWidth disabled
                    />
                    <TextField margin="dense" label="Program Level"
                               value={paymentDetail[0].programLvl} fullWidth disabled
                    />
                    <TextField margin="dense" label="Nric No."
                               value={paymentDetail[0].icNo} fullWidth disabled
                    />
                    {courseDetails}
                </div>
            )
        }
    };

    const miscPaymentDetailSchema = yup.object().shape({
        misc: yup.array().of(yup.object().shape({
            id : yup.number().required("Misc are required"),
            fee: yup.number().required("Fee are required")
        })).optional()
    });

    const renderMiscPayment = () =>{
        return (
            <Formik
                innerRef={formRef}
                initialValues={{
                    misc: [],
                    // tuitionCourse: [ { teacher : 16, programLvl: 1, subjectId: 1, fee: 60 },
                    //     { teacher : 16, programLvl: 1, subjectId: 1, fee: 60 } ],
                    // misc: [ { id : 1, name: "Student Locker", fee: 10 }, { id : 2, name: "Books", fee: 10 } ],
                }}
                validationSchema={miscPaymentDetailSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    // setFormData({studentRegistration : values}); // pass data to global state
                    // resetForm();
                    if (!values.misc) {
                        return;
                    }
                    const transactionDate = moment(selectedTransactionDate).format('DD-MM-YYYY') ;
                    submitStudentMiscPaymentDetail(paymentDetail[0].uuid, transactionDate, paymentType, values);
                    setSubmitting(false);
                }}>
                {({ isSubmitting, setFieldValue, values, errors }) => (
                <div>
                    <FieldArray
                        name="misc"
                        render={ arrayHelpers => (
                            <div>
                                <h3 style={{marginTop: "14px"}}>Misc</h3>
                                {values.misc && values.misc.map((value, index) => {
                                    return (
                                        <div className="miscContainer" key={index}>
                                            <div className="input-field-container" >
                                                <Field name={`misc[${index}].id`}>
                                                    {({ field, form: { touched, errors } }) => (
                                                        <>
                                                            <FormControl variant="filled" className="input-field">
                                                                <InputLabel>Select Item</InputLabel>
                                                                <Select {...field}>
                                                                    {
                                                                        misc.map((value, index) => {
                                                                            return (
                                                                                <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                                                                            );
                                                                        })
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </>
                                                    )}
                                                </Field>
                                                {errors && errors.misc && errors.misc.length > 0 && errors.misc[index] && errors.misc[index].id ? (
                                                    <div className="inline-error">{errors.misc[index].id}</div>
                                                ) : null}
                                            </div>

                                            <div className="input-field-container">
                                                <Field name={`misc[${index}].fee`}>
                                                    {({ field, form: { touched, errors } }) => (
                                                        <>
                                                            <TextField
                                                                {...field}
                                                                label="Fee"
                                                                variant="filled"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                                                                }}
                                                                type="number"
                                                                className="input-field"/>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>
                                            <div className="button-container">
                                                <IconButton aria-label="delete" onClick={() => arrayHelpers.remove(index)}>
                                                    <DeleteIcon/>
                                                </IconButton>
                                            </div>
                                        </div>
                                    ) //here
                                })}
                                <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                                    <h3>{getTotalAmount(values)}</h3>
                                </div>
                                <div style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button variant="contained" color="secondary" onClick={() => arrayHelpers.push({ id : 0, name: "", fee: 0 })} className="submit-button"
                                        disabled={!miscPaymentEnable}>
                                        Add more misc
                                    </Button>
                                </div>
                            </div>
                        )}
                    />
                </div>)}
            </Formik>
        )
    }

    const getTotalAmount = (values) => {
        let totalAmount = 0;
        for (let i = 0; i < values.misc.length; i ++){
            totalAmount += values.misc[i].fee;
        }

        let totalTuitionFee = 0;
        if(paymentDetail == null){
            return;
        }
        for (let i = 0; i < paymentDetail.length; i++){
            if (paymentDetail[i].paymentStatus === PAYMENT_STATUS_STUDENT_PENDING) {
                totalTuitionFee += paymentDetail[i].fee;
            }
        }

        return `Total Amount : RM ${(parseFloat(totalAmount) + parseFloat(totalTuitionFee)).toFixed(2)}`;
    }

    return (
        <div className="student-payment-container">
            <h1 className="header">Student - Tuition Fees</h1>
            <div className="paperContainer">
                <DatePicker
                    className="date-picker"
                    views={["year", "month"]}
                    label="Payment Date"
                    value={selectedDate}
                    onChange={handleDateChange}
                />
                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Program level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>

                <TextField className="text-field" label="Student name" onChange={handleStudentNameChange}/>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

                <div className="table-container">
                    {studentPayment && <FixedHeaderTable columns={columns} rows={studentPayment} buttonContent="View Details" buttonAction={onPayNowClick}/>}
                </div>

            </div>

            <Dialog open={studentDetailDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Payment Details</h2></DialogTitle>
                <DialogContent>
                    {renderStudentDetails()}
                    {renderMiscPayment()}
                    <div style={{display: " inline-flex"}}>
                        <div style={{marginTop:"14px"}}>
                            <FormControl className="form-control" style={{minWidth: width > 1000 ? "180px" : "120px"}}>
                                <InputLabel id="payment-type-label">Payment type</InputLabel>
                                <Select
                                    labelId="payment-type-label"
                                    value={paymentType}
                                    onChange={handlePaymentTypeChange}>
                                    <MenuItem value={"CASH"}>Cash</MenuItem>
                                    <MenuItem value={"BANK"}>Bank</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{marginTop:"14px", marginLeft:"14px"}}>
                            <DatePicker
                                className="date-picker"
                                format="DD/MM/yyyy"
                                views={["year", "month", "date"]}
                                label="Transaction Date"
                                value={selectedTransactionDate}
                                onChange={setTransactionDate}
                            />
                        </div>
                    </div>
                    <div className="inline-error">{errorMsg}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handlePayNow} color="primary">
                        Pay now
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    )
}

export default withRouter(StudentPaymentForm)
